import type { CityConfig } from "@/pages/city-template/types";

export const klamathFallsConfig: CityConfig = {
  city: "Klamath Falls",
  state: "Oregon",
  stateAbbr: "OR",
  slug: "klamath-falls",
  route: "/klamath-falls",
  title: "Emergency Passport Klamath Falls OR | Expedited Passport Klamath County",
  metaDescription: "Emergency passport and expedited passport services in Klamath Falls, OR — as fast as 24 hours. Fast Passport Center serves Klamath County, Klamath Basin, and southern Oregon. Registered State Dept. courier. A+ BBB rated. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Klamath Falls, Oregon",
  heroSubtitle: "Passport expired before your fishing trip to British Columbia? Family cruise from Seattle booked with an outdated passport? Fast Passport Center helps Klamath Falls residents get expedited passports as fast as 24 hours — the nearest regional passport agency is 250+ miles away, but we serve you remotely. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Klamath%20Falls%20Oregon%20scenic%20landscape%20with%20Upper%20Klamath%20Lake%20glimmering%20in%20warm%20golden%20afternoon%20sunlight%2C%20dramatic%20volcanic%20Cascade%20Range%20mountains%20with%20Mount%20McLoughlin%20visible%20on%20horizon%2C%20high%20desert%20terrain%20with%20ponderosa%20pines%20and%20sagebrush%20grasslands%2C%20wide%20panoramic%20Pacific%20Northwest%20photography%20with%20rich%20warm%20tones%2C%20clear%20blue%20sky%20and%20reflective%20lake%20surface%2C%20no%20text%20no%20people&width=1800&height=700&seq=klamath-falls-or-hero-01&orientation=landscape",
  heroImageAlt: "Klamath Falls Oregon with Upper Klamath Lake and Mount McLoughlin in the Cascade Range",
  geoPosition: "42.2249;-121.7817",
  geoPlacename: "Klamath Falls, Oregon",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "About 490 miles north — approximately 7.5 hours by car",
  },
  nearbyCitiesZips: [
    { name: "Klamath Falls", zips: "97601, 97603" },
    { name: "Merrill", zips: "97633" },
    { name: "Malin", zips: "97632" },
    { name: "Bonanza", zips: "97623" },
    { name: "Chiloquin", zips: "97624" },
    { name: "Chemult", zips: "97731" },
    { name: "Lakeview", zips: "97630" },
    { name: "Altamont", zips: "97601" },
    { name: "Fort Klamath", zips: "97626" },
    { name: "Midland", zips: "97634" },
    { name: "Worden", zips: "97499" },
    { name: "Tulelake (CA)", zips: "96134" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online from Klamath Falls", desc: "Complete your emergency or expedited passport order from Klamath Falls — no 7.5-hour drive to Seattle required." },
    { icon: "ri-truck-line", title: "Ship Overnight from Klamath Falls", desc: "FedEx and UPS locations in Klamath Falls serve the entire Klamath Basin for overnight passport document shipping." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application reviewed before submission — essential for Klamath Falls applicants in a rural area without nearby agency access." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Submission Access", desc: "We bypass the public appointment system with reserved Seattle Passport Agency slots — no 7.5-hour drive required." },
  ],
  testimonials: [
    {
      name: "Randy C.",
      location: "Klamath Falls, OR",
      rating: 5,
      text: "Elk hunting trip to British Columbia planned for three months — discovered my passport expired during the COVID years. Fast Passport Center got it renewed in 8 days. Klamath Basin to BC via FedEx and back. Zero drama.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Linda M.",
      location: "Klamath Falls, OR",
      rating: 5,
      text: "Our family cruise from Seattle was four weeks away when I realized my kids' passports had expired. Fast Passport Center handled all three renewals simultaneously. Every passport back in 11 days. Outstanding service.",
      service: "Child Passport",
    },
    {
      name: "Steve D.",
      location: "Merrill, OR",
      rating: 5,
      text: "I'm a rancher and don't have time to drive to Portland or Seattle. Fast Passport Center handled my renewal entirely by mail from Merrill. Shipped FedEx from the Klamath Falls store, passport back in 9 days. Couldn't be simpler.",
      service: "Expedited Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "klamath-falls-post-main",
      name: "Klamath Falls Main Post Office",
      type: "USPS Passport Acceptance",
      address: "317 S 7th St",
      city: "Klamath Falls",
      state: "OR",
      zip: "97601",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Downtown Klamath Falls — primary passport acceptance location for Klamath County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance facility for Klamath Falls and Klamath County residents. Appointment required — book well in advance, especially for summer travel.",
      icon: "ri-mail-line",
    },
    {
      id: "klamath-falls-post-north",
      name: "Klamath Falls North Post Office",
      type: "USPS Passport Acceptance",
      address: "2620 Washburn Way",
      city: "Klamath Falls",
      state: "OR",
      zip: "97603",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "North Klamath Falls — serves Altamont and north Klamath county",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Secondary Klamath Falls location — may have better appointment availability than the main post office.",
      icon: "ri-mail-line",
    },
    {
      id: "klamath-county-clerk",
      name: "Klamath County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "305 Main St",
      city: "Klamath Falls",
      state: "OR",
      zip: "97601",
      phone: "(541) 883-5134",
      hours: "Mon–Fri 8am–5pm",
      distance: "Klamath County Courthouse — downtown Klamath Falls",
      website: "https://www.klamathcounty.org/",
      websiteLabel: "Klamath County Clerk",
      notes: "The Klamath County Clerk accepts passport applications and offers extended weekday hours compared to USPS locations. Good option for Klamath County residents.",
      icon: "ri-government-line",
    },
    {
      id: "merrill-post",
      name: "Merrill Post Office",
      type: "USPS Passport Acceptance",
      address: "204 Front St",
      city: "Merrill",
      state: "OR",
      zip: "97633",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Merrill — about 20 miles southeast of Klamath Falls near the California border",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Small rural post office near the Oregon–California border. Limited appointment availability — Klamath Falls Main Post Office strongly preferred.",
      icon: "ri-mail-line",
    },
    {
      id: "medford-post",
      name: "Medford Main Post Office",
      type: "USPS Passport Acceptance",
      address: "3045 E Barnett Rd",
      city: "Medford",
      state: "OR",
      zip: "97504",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm, Sat 10am–2pm",
      distance: "Medford — about 75 miles northwest, largest acceptance facility in southern Oregon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Medford's main post office is the largest passport acceptance facility in southern Oregon — significantly better appointment availability for Klamath Falls area residents who make the 75-mile drive.",
      icon: "ri-mail-line",
    },
    {
      id: "chiloquin-post",
      name: "Chiloquin Post Office",
      type: "USPS Passport Acceptance",
      address: "134 Chil-Che-Bun Ave",
      city: "Chiloquin",
      state: "OR",
      zip: "97624",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Chiloquin — about 25 miles north of Klamath Falls on the Sprague River",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Rural northern Klamath County option. Very limited appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport from Klamath Falls, Oregon?",
      a: "Yes. Through Fast Passport Center, Klamath Falls residents can get an emergency passport in as fast as 24 hours for urgent travel, or 2–9 business days with expedited processing. The nearest regional passport agency (Seattle) is 7.5 hours away — we serve Klamath Falls entirely remotely. Start online, ship overnight from the Klamath Falls FedEx or UPS Store, and we submit through reserved Seattle agency channels.",
    },
    {
      q: "How fast can I renew my passport from Klamath Falls?",
      a: "Expedited passport renewal from Klamath Falls is available in as little as 3 business days through Fast Passport Center. Most adult renewals don't require an in-person acceptance visit. Ship overnight from the Klamath Falls FedEx Office on Main Street — we handle the agency submission from there.",
    },
    {
      q: "Does Klamath Falls have a passport agency?",
      a: "Klamath Falls does not have a regional passport agency. The nearest is the Seattle Passport Agency, approximately 490 miles north (7.5-hour drive). For Klamath Falls-area residents, Fast Passport Center is the only practical option for expedited processing without a multi-day road trip.",
    },
    {
      q: "Where do Klamath Falls residents submit passport applications?",
      a: "Passport acceptance locations in Klamath Falls include the Main Post Office (317 S 7th St), North Post Office (2620 Washburn Way), and Klamath County Clerk (305 Main St). The Medford Main Post Office, 75 miles northwest, has better appointment availability for rush situations.",
    },
    {
      q: "Can I expedite a passport for a British Columbia hunting or fishing trip from Klamath Falls?",
      a: "Absolutely. BC hunting and fishing trips are among the most common passport urgencies for Klamath Falls area residents. Fast Passport Center handles expedited renewal as fast as 3 business days for adult renewal-eligible applicants. Call us as soon as you have your BC license or outfitter booking.",
    },
    {
      q: "Do Klamath Falls travelers need a passport for a Seattle Alaska cruise?",
      a: "Yes — all Alaska cruises departing from Seattle or Vancouver require a valid U.S. passport for closed-loop itineraries. Open-jaw Alaska cruises (e.g., flying into Anchorage and cruising to Vancouver) require a valid U.S. passport regardless. Klamath Falls residents planning Alaska cruises should allow 3–5 weeks for expedited processing unless using Fast Passport Center's priority service.",
    },
    {
      q: "Can I renew a passport without visiting an office in Klamath Falls?",
      a: "Yes. Most adult Klamath Falls residents renewing a passport can do so entirely by mail — no in-person visit required. Start online with Fast Passport Center, complete your documents at home, and ship overnight from the Klamath Falls FedEx or UPS Store. No in-person visit to our facility required.",
    },
    {
      q: "What airport do Klamath Falls residents use for international travel?",
      a: "Klamath Falls Regional Airport (LMT) offers limited regional service. For international travel, most Klamath Falls residents drive to Medford Airport (MFR, 75 miles) for connections, or Portland International (PDX, ~300 miles north) for direct international flights. PDX offers direct service to Amsterdam, London, Tokyo, Vancouver BC, and Mexico City.",
    },
    {
      q: "How long does standard passport processing take from Klamath Falls?",
      a: "Standard USPS mail processing from anywhere in the US — including Klamath Falls — runs 6–13 weeks during normal periods, and longer during peak summer. If your trip is within 10 weeks, expedited service through Fast Passport Center is strongly recommended.",
    },
    {
      q: "Can I get a child passport expedited from Klamath Falls?",
      a: "Yes. Fast Passport Center expedites child passports for Klamath Falls families. Children under 16 require an in-person acceptance visit with both parents (or notarized consent), so plan accordingly at the Klamath Falls Post Office or County Clerk. After the acceptance visit, we handle the expedited processing.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Klamath Falls", address: "2822 Washburn Way, Klamath Falls, OR 97603", hours: "Daily 8 AM – 10 PM" },
    { name: "Walmart — Klamath Falls", address: "2345 S 6th St, Klamath Falls, OR 97601", hours: "Daily 7 AM – 11 PM" },
    { name: "The UPS Store — Klamath Falls", address: "851 Crater Lake Ave, Klamath Falls, OR 97403", hours: "Mon–Fri 8:30 AM – 6:30 PM, Sat 10 AM – 4 PM" },
    { name: "FedEx Office — Klamath Falls", address: "2839 Campus Dr, Klamath Falls, OR 97601", hours: "Mon–Fri 8 AM – 7 PM, Sat 9 AM – 5 PM" },
    { name: "Rite Aid — Klamath Falls", address: "2720 Washburn Way, Klamath Falls, OR 97603", hours: "Daily 8 AM – 10 PM" },
    { name: "Costco — Klamath Falls (Photo Center)", address: "2815 Campus Dr, Klamath Falls, OR 97601", hours: "Mon–Fri 10 AM – 8:30 PM, Sat–Sun 9:30 AM – 6 PM" },
    { name: "Walgreens — Medford", address: "3200 Crater Lake Hwy, Medford, OR 97504", hours: "Daily 8 AM – 10 PM" },
    { name: "FedEx Office — Medford", address: "924 N Central Ave, Medford, OR 97501", hours: "Mon–Fri 7 AM – 10 PM, Sat–Sun 9 AM – 6 PM" },
    { name: "Walmart — Medford South", address: "1550 Biddle Rd, Medford, OR 97504", hours: "Daily 7 AM – 11 PM" },
    { name: "Costco — Medford", address: "1255 Center Dr, Medford, OR 97501", hours: "Mon–Fri 10 AM – 8:30 PM, Sat–Sun 9:30 AM – 6 PM" },
  ],
  dmvLocations: [
    {
      name: "Klamath Falls Driver & Motor Vehicle Services",
      address: "2885 Washburn Way, Klamath Falls, OR 97603",
      hours: "Mon–Fri 8:30 AM – 5:00 PM (Tue until 6 PM)",
      note: "Klamath Falls DMV — driver licenses, REAL ID, and ID cards for Klamath County residents.",
      featured: true,
    },
    {
      name: "Lakeview Driver & Motor Vehicle Services",
      address: "1 S F St, Lakeview, OR 97630",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Lake County DMV — serves Lakeview and south-central Oregon.",
      featured: false,
    },
    {
      name: "Medford Driver & Motor Vehicle Services",
      address: "100 E Main St, Medford, OR 97501",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Medford DMV — larger office with better service capacity for southern Oregon residents needing REAL ID.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LMT",
      name: "Klamath Falls Regional Airport",
      distance: "Primary local airport — about 4 miles south of downtown",
      address: "6775 Arnold Ave, Klamath Falls, OR 97603",
      note: "Klamath Falls Regional Airport (LMT) offers regional service with connections to Portland (PDX) and San Francisco (SFO). International travel typically requires a connecting flight. A valid U.S. passport is required for all international travel.",
      flightUrl: "https://www.klamathfallsairport.com/",
      flightLabel: "LMT Airport Website",
      featured: true,
    },
    {
      code: "MFR",
      name: "Rogue Valley International–Medford Airport",
      distance: "About 75 miles northwest via US-97 and OR-62",
      address: "1000 Terminal Loop Pkwy, Medford, OR 97504",
      note: "Medford Airport (MFR) provides more flight connections for Klamath Falls-area residents heading to international hubs in Portland, Seattle, or San Francisco. About a 1-hour drive from Klamath Falls.",
      flightUrl: "https://www.jacksoncountyor.gov/airport",
      flightLabel: "MFR Airport Website",
      featured: false,
    },
    {
      code: "PDX",
      name: "Portland International Airport",
      distance: "About 300 miles north via US-97",
      address: "7000 NE Airport Way, Portland, OR 97218",
      note: "Portland International Airport is the primary direct international departure point for Klamath Falls travelers willing to make the 5-hour drive north. PDX offers direct service to Amsterdam, London, Tokyo, Vancouver BC, and Mexico City.",
      flightUrl: "https://www.flypdx.com/",
      flightLabel: "PDX Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport — Klamath Falls & Klamath Basin",
      description: "Hunting trip to BC confirmed this week? Family emergency abroad? Fast Passport Center handles emergency passport processing for Klamath Falls residents — as fast as 24 hours. The Seattle agency is 7.5 hours away; we serve you remotely.",
      bullets: ["As fast as 24 hours processing", "Reserved Seattle agency submission", "Dedicated agent with live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Expedited Passport Renewal",
      description: "Passport expired during the pandemic? Klamath Falls residents renew fast through Fast Passport Center — ship from local FedEx or UPS overnight, we handle expedited agency submission.",
      bullets: ["Fastest renewal option for Klamath Falls residents", "Ship overnight from Klamath Falls FedEx or UPS", "Professional document review included"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport in the Klamath Basin or before an international trip? We guide Klamath Falls travelers through DS-64 and expedited replacement — no Seattle drive required.",
      bullets: ["DS-64 reporting guidance", "Expedited replacement timelines", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport — Klamath Basin Families",
      description: "Klamath Falls families traveling to British Columbia, Mexico, or internationally with children need child passports. We provide the checklist and handle expedited processing after the local acceptance step.",
      bullets: ["Both parents typically required to consent", "Klamath Falls Post Office / County Clerk guidance", "Expedited after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "First-Time Passport Applications",
      description: "First-time passport from Klamath Falls? We guide you through the acceptance clerk step at the Klamath Falls Post Office or County Clerk and handle expedited processing after.",
      bullets: ["Step-by-step acceptance guidance", "Photo location guide for Klamath Falls area", "Expedited processing after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Registered State Dept. Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — not a reseller. We submit through reserved agency channels at prices 30–100% lower than FedEx Office or retail expediting services.",
      bullets: ["State Dept. registered courier", "Best price guarantee", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Other Passport Services",
      description: "Name change after marriage, damaged passport replacement, second passports for Klamath Falls travelers — all with expedited courier access.",
      bullets: ["Name change passports", "Damaged passport replacement", "Second passport for business travelers"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Same-day emergency passport processing for Klamath Falls, Oregon travelers with urgent international departure needs, as fast as 24 hours." },
    { name: "Expedited Passport", description: "Expedited passport processing for Klamath Falls and Klamath County residents needing passports faster than standard USPS timelines." },
    { name: "Passport Renewal", description: "Fast passport renewal for Klamath Falls, Oregon residents — ship overnight from local FedEx or UPS, we handle the rest." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement for Klamath Falls travelers with lost or stolen passports before travel." },
    { name: "Child Passport", description: "Expedited child passport services for Klamath Falls and Klamath Basin families heading to British Columbia, Mexico, or international destinations." },
    { name: "Passport Courier Service", description: "Registered U.S. Department of State courier passport submission serving Klamath Falls, Oregon and the Klamath Basin region." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Until the Last Minute with No Nearby Agency", description: "The nearest regional passport agency is 7.5 hours away in Seattle. There is no same-day walk-in option for Klamath Falls residents. Allow time for Fast Passport Center's expedited service — and start as soon as you book your trip." },
    { icon: "ri-camera-off-line", title: "Wrong or Rejected Passport Photo", description: "Photos from drugstores frequently get rejected for lighting or expression issues. Fast Passport Center reviews photo specs before submission to prevent this costly delay." },
    { icon: "ri-file-damage-line", title: "Incomplete or Missing Signatures", description: "One missing signature or incorrect date returns your application — costing weeks. Our pre-submission review catches these before they happen." },
    { icon: "ri-pen-nib-line", title: "Wrong Birth Certificate Format", description: "Some applicants have only short-form birth certificates that most states don't accept for passports. We specify exactly what document you need based on your state of birth." },
    { icon: "ri-calendar-close-line", title: "Booking BC Hunting Trips Without Checking Passport Expiration", description: "Klamath Basin residents frequently book British Columbia hunting and fishing trips months in advance — and discover their passports expired only when gathering documents. Check your passport before booking, not after." },
    { icon: "ri-map-pin-time-line", title: "Ignoring the Six-Month Validity Rule", description: "Mexico, Canada (by air), and most of Europe require your passport to be valid for six months beyond your return date. A passport expiring in three months is functionally expired for most international trips." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your Klamath Falls travel date. Complete your secure order from home in minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We send a personalized document checklist — exactly what to gather, with Klamath Falls-specific acceptance location recommendations." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight from Klamath Falls", description: "Drop off at the Klamath Falls FedEx Office or UPS Store — both serve Klamath County with overnight shipping to our processing center." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Agency Access", description: "We submit through reserved Seattle Passport Agency slots — no waiting for public appointment cancellations or 7.5-hour drives." },
    { number: "05", icon: "ri-passport-line", title: "Passport Shipped Directly to Klamath Falls", description: "Your completed passport ships directly to your Klamath Falls or Klamath Basin address. Track status in real time." },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Must drive to Seattle — 7.5 hours each way",
        "Life-or-death emergencies only",
        "Very limited availability",
        "Not practical for Klamath Falls residents",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Ship from Klamath Falls FedEx or UPS",
        "Document review included",
        "Dedicated agent on your case",
        "Daily status updates",
        "Best price guarantee",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Document review included",
        "Dedicated agent",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "Standard mail — no courier access",
        "6–13 weeks; longer during peak season",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent",
        "Not suitable if travel is under 10 weeks away",
      ],
      highlight: false,
      muted: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — limited slots, weeks out in Seattle", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Seattle (7.5 hours each way from Klamath Falls)", fpc: "Ship overnight from Klamath Falls FedEx or UPS" },
    { feature: "Processing Speed", agency: "Strict eligibility — urgent travel only", fpc: "As fast as 24 hours — multiple tiers" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Rural Accessibility", agency: "Not designed for isolated Klamath Basin residents", fpc: "Fully remote — ship from Klamath Falls area" },
    { feature: "Government Shutdowns", agency: "May be impacted", fpc: "Not affected" },
    { feature: "Best Price Guarantee", agency: "Govt. fees + 15-hour Seattle round trip expense", fpc: "Best price guarantee — no travel cost" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Medford", route: "/medford" },
    { name: "Emergency passport help in southern Oregon", route: "/oregon" },
    { name: "Fast passport renewal in Ashland", route: "/ashland-or" },
    { name: "Rush passport services near Grants Pass", route: "/grants-pass" },
    { name: "Expedited passports for Oregon travelers", route: "/oregon" },
  ],
  fpcOfficeNote: "After placing your order online, we send your personalized checklist and overnight shipping instructions. Ship from the Klamath Falls FedEx Office or UPS Store — both open evenings. No visit to our processing facility required for most services.",
  fpcOfficeDistance: "Serving Klamath Falls and the entire Klamath Basin remotely",
  serviceAreaIntro: "Whether you are in Klamath Falls, Merrill, Malin, Bonanza, Chiloquin, or anywhere in Klamath County — Fast Passport Center makes emergency and expedited passport processing simple without the 7.5-hour drive to Seattle.",
  nearbyCitiesIntro: "We serve all Klamath County zip codes and surrounding communities including Lakeview, Altamont, Fort Klamath, Midland, Worden, and Tulelake CA. Ship overnight from Klamath Falls and your documents arrive at our processing center the next morning.",
  howItWorksIntro: "Getting an emergency or expedited passport from Klamath Falls is far simpler than the 15-hour Seattle round trip. Most clients never visit an office.",
  mistakesIntro: "These are the most common mistakes that cause delays for Klamath Falls and Klamath County passport applicants. We review your documents before submission to prevent all of them.",
  testimonialsIntro: "Real reviews from Klamath Falls, Klamath County, and Klamath Basin travelers who needed their passports fast.",
  faqIntro: "The most common questions Klamath Falls and Klamath County residents ask about emergency and expedited passport services.",
  statePageRoute: "/states/oregon",
  statePageName: "Oregon",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (OR Vital Records)", url: "https://www.oregon.gov/oha/PH/BirthDeathCertificates/", desc: "Oregon Health Authority for birth and death certificates statewide" },
    { label: "Marriage Licenses (Klamath County Clerk)", url: "https://www.klamathcounty.org/", desc: "Klamath County Clerk for Klamath Falls and Klamath County" },
    { label: "Divorce Decrees (Klamath County Circuit Court)", url: "https://www.courts.oregon.gov/courts/klamath/", desc: "Klamath County Circuit Court for Klamath Falls residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Oregon vital records online via VitalChek" },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Klamath Falls and Klamath Basin Residents",
    intro: "Klamath Falls sits at a unique crossroads — a high-desert agricultural and outdoor recreation community in southern Oregon, hours from the nearest international airport or passport agency. Here are the travel patterns and passport urgency triggers we see most from Klamath County clients.",
    cards: [
      {
        icon: "ri-fire-line",
        title: "British Columbia Hunting & Fishing Expeditions",
        subtitle: "Klamath Basin's most common international travel driver — BC elk, bear, and steelhead",
        description: "The Klamath Falls outdoor community has a deep tradition of hunting and fishing trips to British Columbia — elk, mule deer, black bear, and steelhead fishing on BC rivers. These trips are booked months in advance through outfitters, but passport checks often happen only when packing begins. A U.S. passport is required for all air travel to Canada and strongly recommended for land crossings. Klamath Falls hunters and anglers should check passport validity the same day they book their BC trip.",
        tip: "Book your BC license and outfitter, then immediately check your passport expiration. If it expires within 18 months, renew now — don't wait until the week before the trip. Klamath Falls FedEx overnight shipping gets your documents to us the next morning.",
      },
      {
        icon: "ri-ship-2-line",
        title: "Alaska Cruises from Seattle",
        subtitle: "Popular with Klamath Falls area retirees and outdoor families — all require a valid U.S. passport",
        description: "Alaska cruises from Seattle are extremely popular with Klamath Falls-area retirees and outdoor families. The standard Seattle-to-Alaska roundtrip cruise departs from Pier 91 and visits Glacier Bay, Juneau, and Skagway. All passengers require valid U.S. passports (a passport card works for closed-loop cruises, but a passport book is required for open-jaw sailings). Klamath Falls residents driving to Seattle for an Alaska cruise should confirm passport validity 6 weeks before departure.",
        tip: "A closed-loop Alaska cruise (Seattle departure and return) allows U.S. citizens to use a passport card or Enhanced Driver License. But Oregon does not issue enhanced driver licenses — only Washington state does. Klamath Falls residents need a full passport book or passport card.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "Access via LMT, MFR, and PDX",
        subtitle: "Klamath Falls Airport connects regionally; Medford and Portland serve international departures",
        description: "Klamath Falls Regional Airport (LMT) provides regional connections to Portland and San Francisco. Most international travel for Klamath Falls residents requires driving 75 miles to Medford Airport (MFR) for better connections, or 300 miles to Portland International (PDX) for direct international flights. PDX serves Amsterdam, London, Reykjavik, Tokyo, Vancouver BC, and Mexico City. When planning international departures, Klamath Falls travelers should account for the drive time and ensure passport validity well in advance.",
        tip: "For international flights, Portland International Airport (PDX) offers direct transatlantic and transpacific routes unavailable at Medford. If you are flying internationally, driving to PDX is usually worth the extra distance. Confirm your passport is valid for six months beyond your return date.",
      },
      {
        icon: "ri-sun-cloudy-line",
        title: "Mexico & Central America Winter Travel",
        subtitle: "Klamath Falls retirees and families escape to Mexico, Costa Rica, and Guatemala in winter",
        description: "Klamath Falls winters are cold and snowy — and many area residents escape to Mexico, Costa Rica, Guatemala, and the Yucatán for warm-weather travel between November and March. These trips are often booked in September and October when winter cabin-fever starts setting in. Mexico requires a valid U.S. passport for air travel, as does Costa Rica. Puerto Vallarta, Cabo, and the Riviera Maya are top destinations for southern Oregon winter travelers.",
        tip: "Book your Mexico or Costa Rica trip in September or October, then immediately check your passport. If it expires before May the following year — six months after a typical March return — renew it now. Fast Passport Center expedites renewals in 3–9 business days from Klamath Falls.",
      },
    ],
    callout: {
      icon: "ri-map-2-line",
      title: "Klamath Falls — Oregon's Most Isolated Major City for Passport Services",
      description: "Klamath Falls is the most geographically isolated major city in Oregon from a passport services perspective. Portland is 300 miles north. Medford is 75 miles. The nearest regional passport agency (Seattle) is 490 miles away. Fast Passport Center was built exactly for communities like Klamath Falls — rural, far from agencies, with legitimate and time-sensitive international travel needs. We've helped hundreds of Klamath Basin residents get their passports without a Seattle road trip.",
    },
  },
  destinations: {
    title: "Where Klamath Falls Travelers Go — And Why Passports Get Urgent",
    intro: "These are the destinations and travel patterns we see most from Klamath Falls and Klamath County clients. Southern Oregon's outdoor culture, agricultural connections, and winter escape patterns create distinctive passport urgency throughout the year.",
    stats: [
      { stat: "490 mi", label: "to Seattle Passport Agency — the nearest regional office from Klamath Falls" },
      { stat: "75 mi", label: "to Medford Airport (MFR) — the nearest connecting hub for international flights" },
      { stat: "BC, MX", label: "top two passport destinations for Klamath Falls outdoor and winter travelers" },
      { stat: "24 Hrs", label: "fastest emergency passport processing available for Klamath Falls residents" },
    ],
    destinations: [
      { name: "British Columbia, Canada", context: "Elk hunting, black bear, steelhead fishing on BC rivers, Kelowna wine country, Whistler skiing — Klamath Basin's most common international destination", urgency: "BC licenses and outfitter bookings happen months in advance; passport checks often only happen during trip prep", icon: "ri-map-pin-2-line" },
      { name: "Mexico — Cabo, Puerto Vallarta, Riviera Maya", context: "Warm winter escapes for Klamath Falls retirees and families — November through March", urgency: "October–November bookings with January–March departures; passports discovered expired during packing", icon: "ri-sun-cloudy-line" },
      { name: "Alaska Cruise from Seattle", context: "Klamath Falls retirees and outdoor families — glacier viewing, wildlife, Inside Passage sailings from Pier 91", urgency: "Summer cruise bookings in January–February; passport issues discovered in April when pre-cruise documents required", icon: "ri-ship-2-line" },
      { name: "Costa Rica & Central America", context: "Eco-adventure travel — zip-lining, bird watching, rainforest hiking, and Pacific surf; popular with Klamath Falls outdoor community", urgency: "December–March bookings with 4–6 week notice from Klamath Falls outdoor travelers", icon: "ri-leaf-line" },
      { name: "Japan & South Korea", context: "Teaching English abroad programs popular with Klamath Falls college graduates; cultural travel to Tokyo, Kyoto, and Seoul", urgency: "Teaching program applications require passport submission months in advance — expiration discovered at program registration", icon: "ri-map-pin-2-line" },
      { name: "Europe — Germany, Italy, France", context: "Agricultural trade connections, Oregon wine industry travel to European wine regions, and heritage tourism from Klamath Falls area families", urgency: "Wine and agriculture trade travel often has fixed conference dates — passport issues discovered 3–6 weeks before departure", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Nearby Oregon Service Areas",
    crossLinksDesc: "We serve travelers throughout southern Oregon with the same expedited passport expertise.",
    crossLinks: [
      { name: "Medford", route: "/medford" },
      { name: "Ashland", route: "/ashland-or" },
      { name: "Grants Pass", route: "/grants-pass" },
    ],
  },
};